/** TN ticket-group split bitmap: bit (qty - 1) set means that purchase quantity is allowed. */
export const splitBitmapAllowsQty = (bitmap, qty) => {
  const n = Number.parseInt(String(bitmap || ''), 10);
  if (!Number.isFinite(n) || n <= 0) return true;
  const bit = 1 << (qty - 1);
  return (n & bit) !== 0;
};

export const SEATICS_CHECKOUT_QTY_REQUIRED_MSG =
  'Please select how many tickets you want from this ticket group before continuing to checkout.';

const SEATICS_MAX_CHECKOUT_QTY = 20;

/** Whether this ticket group can be purchased at the given quantity (inventory + split rules). */
export const ticketGroupAllowsQuantity = (ticketGroup, qty) => {
  const quantity = Number.parseInt(String(qty), 10);
  if (!Number.isFinite(quantity) || quantity < 1 || quantity > SEATICS_MAX_CHECKOUT_QTY) {
    return false;
  }
  const tgQty = Number(ticketGroup?.tgQty || 0);
  if (tgQty > 0 && quantity > tgQty) return false;
  return splitBitmapAllowsQty(ticketGroup?.tgSplitsBitmap, quantity);
};

/**
 * Resolve quantity for map/sidebar checkout. Returns null when Seatics did not pass a valid
 * quantity for this ticket group (e.g. user skipped "how many tickets" on a 2–4 split group).
 */
export const resolveCheckoutQuantityFromTicketGroup = (ticketGroup, qtyFromSeatics) => {
  const parsed = Number.parseInt(String(qtyFromSeatics), 10);
  if (!Number.isFinite(parsed) || parsed < 1) return null;
  if (!ticketGroupAllowsQuantity(ticketGroup, parsed)) return null;
  return parsed;
};

/** Lowest purchase quantity allowed by split rules and inventory (e.g. 2 when singles are disallowed). */
export const getMinimumAllowedQuantity = (ticketGroup, maxQty = SEATICS_MAX_CHECKOUT_QTY) => {
  for (let q = 1; q <= maxQty; q += 1) {
    if (ticketGroupAllowsQuantity(ticketGroup, q)) return q;
  }
  return null;
};

export const checkoutQuantityError = () => {
  const err = new Error(SEATICS_CHECKOUT_QTY_REQUIRED_MSG);
  err.isFriendlyCheckoutMessage = true;
  return err;
};
